import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewRegimen = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'accesos',
        name: 'Accesos',
        component: ViewRegimen,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
